import React, { createContext, type PropsWithChildren, useContext } from 'react';

import { SupportUrlKeys, type SupportUrls } from '../../../common/types';

import { useFilters } from './filters';
import { useFocusState } from './focus-state';
import type { HeartbeatsContextProps } from './types';

const HeartbeatsContext = createContext<HeartbeatsContextProps>({
	focusState: {
		isOpen: false,
		open: () => {},
		close: () => {},
	},
	filters: {
		searchText: '',
		statuses: [],
		handleSearchTextChange: () => {},
		handleStatusesChange: () => {},
	},
	isTransitioning: false,
	opsgenieGlobalHeartbeatsUrl: undefined,
	isPrimaryAdmin: false,
	supportUrls: {
		[SupportUrlKeys.API_DOCUMENTATION]: '',
		[SupportUrlKeys.OG_GLOBAL_HEARTBEATS]: '',
		[SupportUrlKeys.API_PING_URL]: '',
		[SupportUrlKeys.HEARTBEATS_API]: '',
		[SupportUrlKeys.CREATE_API_TOKEN]: '',
		[SupportUrlKeys.EMAIL_INSTRUCTIONS]: '',
	},
});

export const useHeartbeatsContext = () => useContext(HeartbeatsContext);

export const HeartbeatsProvider = ({
	children,
	isTransitioning,
	isPrimaryAdmin,
	supportUrls,
}: PropsWithChildren<{
	isTransitioning?: boolean;
	isPrimaryAdmin?: boolean;
	supportUrls: SupportUrls;
}>) => {
	const filters = useFilters();
	const focusState = useFocusState();

	return (
		<HeartbeatsContext.Provider
			value={{
				filters,
				focusState,
				isTransitioning,
				isPrimaryAdmin,
				supportUrls,
			}}
		>
			{children}
		</HeartbeatsContext.Provider>
	);
};
